import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

function BarangayProfileContent({
  handleEdit,
  barangayProfileId,
  getSingleBarangayProfile,
  barangayProfileInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(barangayProfileId)) return;
    getSingleBarangayProfile(barangayProfileId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(barangayProfileId)) return;
    getSingleBarangayProfile(barangayProfileId);
  }, [barangayProfileId]);

  const otherFees = _.get(barangayProfileInfo, 'attributes.other_fee_codes', []);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {!_.isEmpty(barangayProfileInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(barangayProfileInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                </div>
              </div>
            </div>
            <div className='row form-wrapper m-0 py-3'>
              <div className='col-12'>
                <table className="transaction-table table table-borderless table-sm ">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="310">
                        Barangay Business Clearance Integrated:
                      </td>
                      <td colSpan={4}>
                        <b>
                          {_.get(
                            barangayProfileInfo,
                            'attributes.with_barangay_clearance'
                          ) ? 'Yes' : 'No'}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='col-4'>
                <div className='py-3'>
                  <img
                    className="w-100 rounded"
                    src={
                      !_.isObject(
                        _.get(barangayProfileInfo, 'attributes.logo') || ''
                      )
                        ? _.get(barangayProfileInfo, 'attributes.logo') ||
                          ImagePlaceholder
                        : _.get(barangayProfileInfo, 'logo.cdnUrl') ||
                          ImagePlaceholder
                    }
                    alt=""
                  />
                </div>
              </div>
              <div className="col-8">
                <div className="mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Barangay Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(barangayProfileInfo, 'attributes.barangay_name')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Barangay Code
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              barangayProfileInfo,
                              'attributes.barangay_code'
                            )}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-4'>
                <div className='pb-3'>
                  <img
                    className="w-100 rounded"
                    src={
                      !_.isObject(
                        _.get(barangayProfileInfo, 'attributes.signatory_signature') || ''
                      )
                        ? _.get(barangayProfileInfo, 'attributes.signatory_signature') ||
                          ImagePlaceholder
                        : _.get(barangayProfileInfo, 'signatory_signature.cdnUrl') ||
                          ImagePlaceholder
                    }
                    alt=""
                  />
                </div>
              </div>
              <div className="col-8">
                <div className="mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Signatory Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              barangayProfileInfo,
                              'attributes.signatory_name'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Signatory Designation
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              barangayProfileInfo,
                              'attributes.signatory_designation'
                            )}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr />
              <div className="table-responsive mt-2 border-top">
                <table className="table table-borderless">
                  <thead>
                    <tr className="text-center">
                      <th scope="col" className="px-1">Fees</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!_.isEmpty(otherFees) ? (
                      <React.Fragment>
                        {otherFees.map(item => {
                          return (
                            <tr className="top-border" key={item}>
                              <td className="font-weight-bold">
                                {item}
                              </td>
                            </tr>
                        )})}
                      </React.Fragment>
                    ) : (
                      <tr className="top-border text-center">
                        <td className="font-weight-bold">
                          No Record Fees
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>            
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BarangayProfileContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  getSingleBarangayProfile: PropTypes.instanceOf(Function).isRequired,
  barangayProfileInfo: PropTypes.instanceOf(Object).isRequired,
  barangayProfileId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  barangayProfileInfo:
    _.get(api, `${c.GET_SINGLE_BARANGAY_PROFILE}.item`) || {},
  barangayProfileId: _.get(match, 'params.barangayProfileId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayProfileContent);
